import { Flex, Typography } from "antd"
import dayjs from "dayjs"

import MonthStatus from "../MonthStatus/MonthStatus"

import "./MonitoringProgramEdges.less"

const { Text } = Typography
const MonitoringProgramEdges = ({
  intervalWidth,
  startOffset,
  isFinishTextHidden = false,
  startDate,
  endDate
}) => {
  return (
    <Flex className="monitoring-program-edges">
      <div
        className="start-block"
        style={{
          marginLeft: startOffset,
          width: `calc(${intervalWidth} - 15px)`,
          flexShrink: 0
        }}
      >
        <Flex gap={4} vertical>
          <Text strong>{dayjs(startDate).format("D MMMM, YYYY")}</Text>
          <Text style={{ color: "#F6B60E", fontSize: "12px", lineHeight: "16px" }} strong>
            Monitoring program start
          </Text>
        </Flex>
      </div>
      <Flex gap={8} className="end-block">
        <Flex gap={8} vertical align="center">
          <MonthStatus icon="bh_vamp_flag" variant="warning" />
          <div className="vertical-dashed-line" />
        </Flex>
        {!isFinishTextHidden && (
          <Flex gap={4} vertical>
            <Text strong>{dayjs(endDate).format("D MMMM, YYYY")}</Text>
            <Text type="secondary" style={{ fontSize: "12px", lineHeight: "16px" }}>
              Monitoring program finish
            </Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

export default MonitoringProgramEdges
